import React, { useContext } from "react";
import { AppContext } from "../../App";
import Can from "../can/Can";
import { payment } from "../../rbac-consts";
import { default as ClientPaymentDetailsContainer } from "./client/PaymentDetailsContainer";
import { default as SupportPaymentDetailsContainer } from "./support/PaymentDetailsContainer";
import { default as AdminPaymentDetailsContainer } from "./admin/PaymentDetailsContainer";
import { default as SuperAdminPaymentDetailsContainer } from "./superAdmin/PaymentDetailsContainer";

const PaymentDetailsWrapper = ({ match }) => {

  const { user } = useContext(AppContext);

  return (
    <>
      <Can
        role={user.roles}
        perform={payment.USER}
        yes={() => (
          <ClientPaymentDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={payment.SUPPORT}
        yes={() => (
          <SupportPaymentDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={payment.ADMIN}
        yes={() => (
          <AdminPaymentDetailsContainer match={match} />
        )}
      />
      <Can
        role={user.roles}
        perform={payment.SUPER_ADMIN}
        yes={() => (
          <SuperAdminPaymentDetailsContainer match={match} />
        )}
      />
    </>
  );
};

export default PaymentDetailsWrapper;